import { getApiKey } from "../../utils/apiKey";
import React from "react";
import Header from "../header";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ProductMainCard from "../global/ProductMainCard";
import { Swiper, SwiperSlide } from "swiper/react";

class SpecialItems extends React.Component {
  state = {
    data: [],
    loading: true,
  };
  componentDidMount() {
    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(
        `${apiCall_domain}/customer/special-section?want=${
          this.props.match.params.slug
        }&page=${this.props.match.params.page || 1}`,
        {
          headers: Headers,
        },
      )
      .then((res) => {
        const lastChance = res.data.items.filter(
          (item) => +item.deadline < 86400,
        );
        this.setState({
          lastChance,
          data: res.data,
          loading: false,
        });
      });
  }
  render() {
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <Header showSearchBar={true} title={this.state.data?.name[0]} />
            {this.state.lastChance.length ? (
              <div className="index_wrapper col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div
                  className={`AmazingSection${
                    this.state.Golden ? " golden" : ""
                  }`}
                  id={`AmazingSection_${this.state.data?.slug}`}
                >
                  <div className="opportunity">
                    <div className="lastChance">
                      <span className="chanceTitle">آخرین فرصت</span>
                      <span className="line"></span>
                    </div>
                    <Swiper slidesPerView={2} spaceBetween={10}>
                      {this.state.lastChance.map((item, index) => (
                        <SwiperSlide>
                          <ProductMainCard
                            key={index}
                            data={item}
                            countDown={true}
                            deadline={item.deadline}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="all_items">
              {this.state.data?.items.map((item, index) => (
                <div className="all_items_wrapper SpecialItems_CONTAINER">
                  <div className="Amazing-items">
                    <ProductMainCard
                      key={index}
                      data={item}
                      countDown={true}
                      deadline={item.deadline}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="pag col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Stack spacing={2}>
                <Pagination
                  count={this.state.data.last_page}
                  page={this.state.data.page}
                  onChange={(e, value) => {
                    this.props.history.push(`?page=${value}`);
                    this.props.history.go(0);
                  }}
                />
              </Stack>
            </div>
          </>
        )}
      </>
    );
  }
}
export default SpecialItems;
